import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import Loading from "../../../components/loading";
import { ReviewInvoiceState } from "../hooks/use-review-invoice";

interface ProcessingDialogParams {
  state: ReviewInvoiceState;
}

export default function ProcessingDialog({
  state: { processingModalOpened, messages },
}: ProcessingDialogParams) {
  return (
    <Transition appear show={processingModalOpened} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={() => { }}
      >
        <div className="flex items-center justify-center min-h-screen">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-700"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 transition-opacity bg-black bg-opacity-30" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="">
              <div className="relative max-w-md mx-auto bg-white rounded-md shadow-md">
                <div className="p-10">
                  <Dialog.Title className="text-2xl text-primary-blue mb-2 font-semibold tracking-[0.07rem]">
                    Processing charts...
                  </Dialog.Title>
                  <div className="mt-16">
                    <Loading />
                  </div>
                  <div className="h-24 px-4 py-2 mt-10 overflow-y-scroll bg-blue-100 rounded-md">
                    {messages.map((message, i) => (
                      <div key={`${i}-message`} className="text-sm">
                        {message}
                      </div>
                    ))}
                  </div>
                  <div className="mt-2 text-sm text-[#272727]">
                    This might take awhile, please don't close this tab
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
